<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template v-slot:assignation="{ item }">
            <span v-if="!!item.structure">
                {{ item.structure.venue.client.name }} - {{ item.structure.venue.name }} ({{
                    item.structure.name
                }})
            </span>
        </template>

        <template v-slot:price="{ item }">
            {{ item.price | currency }}
        </template>

        <template #munition="{item}">
            {{ item.item_type.fields.some(field => field.slug === 'cantidad-de-municion')?item.munition: 'N/A' }}
        </template>

        <template slot="actions" slot-scope="{ item }">
            <nobr>
                <b-btn
                    size="sm"
                    variant="primary"
                    v-if="item.assigned"
                    :disabled="inProgress"
                    @click="unassign(item)"
                    ><i class="fa fa-times"></i
                ></b-btn>
                <!-- <b-btn
                    size="sm"
                    variant="primary"
                    :disabled="inProgress"
                    @click="onEdit(item)"
                    ><i class="fa fa-edit"></i
                ></b-btn> -->
                <b-btn
                    size="sm"
                    variant="danger"
                    :disabled="inProgress"
                    @click="onDelete(item)"
                    ><i class="fa fa-trash"></i
                ></b-btn>
            </nobr>
        </template>
    </app-data-table>
</template>
<script>
import fields from './fields'
export default {
    data() {
        return {
            fields,
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        onEdit: {
            type: Function,
            required: true,
        },
        onDelete: {
            type: Function,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
        unassign: {
            type: Function,
            required: true,
        },
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
</script>
